module.exports = __webpack_public_path__ + "static/media/tachometer-average.936845fb.svg";